<article class="bre-b-container">
  <div class="bre-b-card">
    <header
      class="bre-b-card__header"
      [class.bre-b-card__header--qr]="!isInitialLoading && estado === estadoModel.QR"
    >
      <div class="bre-b-card__header-content">
        @if (!isInitialLoading) {
        <button type="button" class="bre-b-card__header-back" (click)="goBack()" aria-label="Volver">
          <svg
            class="bre-b-card__header-back-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M25 30L15 20L25 10"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        }
        @if (isInitialLoading) {
        <span class="bre-b-card__header-back bre-b-card__header-back--placeholder" aria-hidden="true"></span>
        }
        <div class="bre-b-card__header-text">
          <h1 class="bre-b-card__header-title">
            @if (isInitialLoading) {
              Cargando
            } @else if (estado === estadoModel.SELECTION || estado === estadoModel.BREB_METHOD_SELECTION) {
              Seleccione un método de pago
            } @else if (estado === estadoModel.QR) {
              Pago escaneando un QR
            } @else if (showStandardProcessingView) {
              Procesando pago
            } @else if (estado === estadoModel.APPROVED) {
              Pago exitoso
            } @else if (estado === estadoModel.REFUSED) {
              Pago rechazado
            } @else if (estado === estadoModel.EXPIRED) {
              Tiempo expirado
            } @else {
              Pago usando llave
            }
          </h1>
          <p class="bre-b-card__header-subtitle">
            @if (isInitialLoading) {
              Obteniendo la información de tu pago…
            } @else if (estado === estadoModel.EXPIRED && expirationFormattedColombia) {
              Tiempo límite: {{ expirationFormattedColombia }} (hora Colombia)
            } @else {
              Todos los métodos son seguros y encriptados
            }
          </p>
        </div>
        <div
          class="bre-b-card__header-logo"
          [class.hide-on-mobile]="
            isInitialLoading ||
            estado === estadoModel.SELECTION ||
            estado === estadoModel.BREB_METHOD_SELECTION ||
            estado === estadoModel.PENDING ||
            showStandardProcessingView ||
            estado === estadoModel.APPROVED ||
            estado === estadoModel.EXPIRED ||
            estado === estadoModel.REFUSED ||
            estado === estadoModel.QR
          "
        >
          <span class="bre-b-card__header-powered">Powered By</span>
          <img src="./assets/svg/bre-b/clinng-logo.svg" alt="CL!NNG" class="bre-b-card__header-clinng-logo">
        </div>
      </div>
    </header>
    <div
      class="bre-b-card__content"
      [ngClass]="{
        'bre-b-card__content--selection':
          !isInitialLoading &&
          (estado === estadoModel.SELECTION ||
            (estado === estadoModel.BREB_METHOD_SELECTION && !isGeneratingMethod)),
        'bre-b-card__content--success': estado === estadoModel.APPROVED,
        'bre-b-card__content--error':
          estado === estadoModel.REFUSED || estado === estadoModel.EXPIRED,
        'bre-b-card__content--qr': estado === estadoModel.QR,
      }"
    >
    @if (isInitialLoading) {
      <div class="bre-b-card__initial-loading" role="status" aria-live="polite" aria-busy="true">
        <div class="bre-b-card__loading-spinner">
          <img src="./assets/svg/bre-b/loading-spinner.svg" alt="" class="bre-b-card__loading-spinner-img">
        </div>
        <p class="bre-b-card__initial-loading-message">Preparando la pantalla de pago…</p>
      </div>
    }
    @if (!isInitialLoading && estado === estadoModel.SELECTION) {
      <div class="bre-b-card__selection">
        <h2 class="bre-b-card__selection-title">¿Cómo te gustaría realizar el pago?</h2>
        <div class="bre-b-card__selection-options">
          <div
            class="bre-b-card__selection-option"
            [class.bre-b-card__selection-option--active]="selectedMethod === 'bre-b'"
            (click)="selectMethod('bre-b')"
          >
            <span class="bre-b-card__selection-radio" [class.bre-b-card__selection-radio--checked]="selectedMethod === 'bre-b'">
              @if (selectedMethod === 'bre-b') {
                <svg class="bre-b-card__selection-check" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
              }
            </span>
            <span class="bre-b-card__selection-label">Bre-b</span>
            <img src="./assets/img/bre-b.png" alt="Bre-B" class="bre-b-card__selection-logo" />
          </div>
          <div
            class="bre-b-card__selection-option"
            [class.bre-b-card__selection-option--active]="selectedMethod === 'tarjeta'"
            (click)="selectMethod('tarjeta')"
          >
            <span class="bre-b-card__selection-radio" [class.bre-b-card__selection-radio--checked]="selectedMethod === 'tarjeta'">
              @if (selectedMethod === 'tarjeta') {
                <svg class="bre-b-card__selection-check" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
              }
            </span>
            <span class="bre-b-card__selection-label">Tarjeta</span>
            <span class="bre-b-card__selection-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M3.33398 14.1749H36.6673" stroke="#4E2CD1" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10 27.5083H13.3333" stroke="#4E2CD1" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17.5 27.5083H24.1667" stroke="#4E2CD1" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.734 5.84155H29.2506C35.184 5.84155 36.6673 7.30822 36.6673 13.1582V26.8416C36.6673 32.6916 35.184 34.1582 29.2673 34.1582H10.734C4.81732 34.1749 3.33398 32.7082 3.33398 26.8582V13.1582C3.33398 7.30822 4.81732 5.84155 10.734 5.84155Z" stroke="#4E2CD1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
        </div>
        <div class="bre-b-card__selection-footer">
          <button
            class="bre-b-card__selection-continue"
            [class.bre-b-card__selection-continue--disabled]="!selectedMethod"
            [disabled]="!selectedMethod"
            (click)="onContinue()"
          >
            Continuar
          </button>
          <div class="bre-b-card__footer-logo bre-b-card__footer-logo--selection-mobile">
            <span class="bre-b-card__footer-powered">Powered By</span>
            <img src="./assets/svg/bre-b/mobile-logo.svg" alt="CL!NNG" class="bre-b-card__footer-clinng-logo">
          </div>
        </div>
      </div>
    }

    @if (!isInitialLoading && estado === estadoModel.BREB_METHOD_SELECTION && !isGeneratingMethod) {
      <div class="bre-b-card__selection">
        <h2 class="bre-b-card__selection-title">¿Cómo te gustaría realizar el pago?</h2>
        <div class="bre-b-card__selection-options">
          <div
            class="bre-b-card__selection-option"
            [class.bre-b-card__selection-option--active]="selectedBreBMethod === 'llave'"
            (click)="selectBreBMethod('llave')"
          >
            <span class="bre-b-card__selection-radio" [class.bre-b-card__selection-radio--checked]="selectedBreBMethod === 'llave'">
              @if (selectedBreBMethod === 'llave') {
                <svg class="bre-b-card__selection-check" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
              }
            </span>
            <span class="bre-b-card__selection-label">Usando llave</span>
            <span class="bre-b-card__selection-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M11.668 10.7002C13.4081 10.7002 14.9697 11.1266 16.3691 11.9736C17.7864 12.8315 18.9044 13.9574 19.7324 15.3564L19.9355 15.7002H34.293C34.4253 15.7002 34.5533 15.7246 34.6807 15.7754C34.7964 15.8216 34.9039 15.8915 35.0049 15.9932L35.0059 15.9951L38.3398 19.3281C38.4432 19.4315 38.4989 19.5254 38.5283 19.6084C38.5691 19.7234 38.592 19.8541 38.5928 20.0039C38.5935 20.1489 38.5707 20.2741 38.5303 20.3848C38.4978 20.4734 38.4391 20.5703 38.3359 20.6748L33.0479 25.9629C32.9767 26.0341 32.8864 26.0975 32.7676 26.1484C32.6253 26.2094 32.4895 26.2472 32.3604 26.2656C32.2663 26.279 32.1709 26.2725 32.0684 26.2432C31.9745 26.2163 31.8803 26.1678 31.7832 26.0869L31.7686 26.0762L31.7549 26.0654L29.5879 24.4404L29.167 24.124L28.7461 24.4414L26.3711 26.2324L26.3633 26.2393L26.3555 26.2451C26.2803 26.3052 26.2006 26.3488 26.1133 26.3779C26.0143 26.4109 25.9223 26.4248 25.835 26.4248C25.7467 26.4248 25.642 26.4099 25.5186 26.3721C25.4168 26.3409 25.3379 26.2982 25.2744 26.2471L25.2568 26.2324L25.2383 26.2197L22.6963 24.4277L22.5146 24.2998H19.9355L19.7324 24.6436C18.9032 26.0427 17.7845 27.1685 16.3672 28.0264C14.9677 28.8734 13.4069 29.2998 11.668 29.2998C9.07372 29.2998 6.89176 28.3996 5.08008 26.5879C3.2684 24.7762 2.36816 22.5942 2.36816 20C2.36816 17.4058 3.2684 15.2238 5.08008 13.4121C6.89176 11.6004 9.07372 10.7002 11.668 10.7002ZM11.668 12.6338C9.64751 12.6338 7.90063 13.3611 6.46484 14.7969C5.02906 16.2327 4.30176 17.9795 4.30176 20C4.30176 22.0205 5.02906 23.7673 6.46484 25.2031C7.90063 26.6389 9.64751 27.3662 11.668 27.3662C13.3774 27.3662 14.901 26.8435 16.21 25.7969C17.3626 24.8752 18.176 23.7272 18.6426 22.3662H23.1113L25.3477 23.9463L25.7617 24.2393L26.1689 23.9365L29.1582 21.7119L31.6973 23.6787L32.1855 24.0557L36.2412 20L35.7461 19.5049L34.0801 17.8379L33.875 17.6338H18.6436C18.1763 16.2728 17.3617 15.1249 16.21 14.2031C14.902 13.1564 13.3783 12.6338 11.668 12.6338ZM11.6699 17.3662C12.3951 17.3645 13.0025 17.6158 13.5283 18.1416C14.054 18.6674 14.3043 19.2736 14.3018 19.9971C14.2991 20.7249 14.047 21.3354 13.5254 21.8633C13.0085 22.3864 12.4033 22.6373 11.6709 22.6338H11.668C10.9383 22.6338 10.3314 22.3821 9.80957 21.8604C9.28768 21.3385 9.03507 20.7304 9.03418 19.999C9.03333 19.2691 9.28556 18.6629 9.80859 18.1426C10.3336 17.6204 10.942 17.368 11.6699 17.3662Z" fill="white" stroke="#4E2CD1" stroke-width="1.4"/>
              </svg>
            </span>
          </div>
          <div
            class="bre-b-card__selection-option"
            [class.bre-b-card__selection-option--active]="selectedBreBMethod === 'qr'"
            (click)="selectBreBMethod('qr')"
          >
            <span class="bre-b-card__selection-radio" [class.bre-b-card__selection-radio--checked]="selectedBreBMethod === 'qr'">
              @if (selectedBreBMethod === 'qr') {
                <svg class="bre-b-card__selection-check" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
              }
            </span>
            <span class="bre-b-card__selection-label">Escaneando un QR</span>
            <span class="bre-b-card__selection-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M35.4154 14.8617V9.72171C35.4154 8.35894 34.874 7.05198 33.9104 6.08836C32.9468 5.12473 31.6398 4.58337 30.277 4.58337H25.137M25.137 35.4167H30.277C31.6398 35.4167 32.9468 34.8753 33.9104 33.9117C34.874 32.9481 35.4154 31.6411 35.4154 30.2784V25.1384M4.58203 25.1384V30.2784C4.58203 31.6411 5.12339 32.9481 6.08701 33.9117C7.05064 34.8753 8.35759 35.4167 9.72037 35.4167H14.8604M14.8604 4.58337H9.72037C8.35759 4.58337 7.05064 5.12473 6.08701 6.08836C5.12339 7.05198 4.58203 8.35894 4.58203 9.72171V14.8617M15.7204 9.72171H11.2204C10.8225 9.72171 10.441 9.87974 10.1597 10.161C9.8784 10.4424 9.72037 10.8239 9.72037 11.2217V15.7217C9.72037 16.1195 9.8784 16.5011 10.1597 16.7824C10.441 17.0637 10.8225 17.2217 11.2204 17.2217H15.7204C16.1182 17.2217 16.4997 17.0637 16.781 16.7824C17.0623 16.5011 17.2204 16.1195 17.2204 15.7217V11.2217C17.2204 10.8239 17.0623 10.4424 16.781 10.161C16.4997 9.87974 16.1182 9.72171 15.7204 9.72171ZM15.7204 22.7467H11.2204C10.8225 22.7467 10.441 22.9047 10.1597 23.186C9.8784 23.4674 9.72037 23.8489 9.72037 24.2467V28.7467C9.72037 29.1445 9.8784 29.5261 10.1597 29.8074C10.441 30.0887 10.8225 30.2467 11.2204 30.2467H15.7204C16.1182 30.2467 16.4997 30.0887 16.781 29.8074C17.0623 29.5261 17.2204 29.1445 17.2204 28.7467V24.2467C17.2204 23.8489 17.0623 23.4674 16.781 23.186C16.4997 22.9047 16.1182 22.7467 15.7204 22.7467ZM28.777 9.72171H24.277C23.8792 9.72171 23.4977 9.87974 23.2164 10.161C22.9351 10.4424 22.777 10.8239 22.777 11.2217V15.7217C22.777 16.1195 22.9351 16.5011 23.2164 16.7824C23.4977 17.0637 23.8792 17.2217 24.277 17.2217H28.777C29.1749 17.2217 29.5564 17.0637 29.8377 16.7824C30.119 16.5011 30.277 16.1195 30.277 15.7217V11.2217C30.277 10.8239 30.119 10.4424 29.8377 10.161C29.5564 9.87974 29.1749 9.72171 28.777 9.72171ZM28.777 22.7784H24.277C23.8792 22.7784 23.4977 22.9364 23.2164 23.2177C22.9351 23.499 22.777 23.8806 22.777 24.2784V28.7784C22.777 29.1762 22.9351 29.5577 23.2164 29.839C23.4977 30.1203 23.8792 30.2784 24.277 30.2784H28.777C29.1749 30.2784 29.5564 30.1203 29.8377 29.839C30.119 29.5577 30.277 29.1762 30.277 28.7784V24.2784C30.277 23.8806 30.119 23.499 29.8377 23.2177C29.5564 22.9364 29.1749 22.7784 28.777 22.7784Z" stroke="#4E2CD1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
        </div>
        <div class="bre-b-card__selection-footer">
          <button
            class="bre-b-card__selection-continue"
            [class.bre-b-card__selection-continue--disabled]="!selectedBreBMethod || isGeneratingMethod"
            [disabled]="!selectedBreBMethod || isGeneratingMethod"
            (click)="onContinueBreB()"
          >
            Continuar
          </button>
          <div class="bre-b-card__footer-logo bre-b-card__footer-logo--selection-mobile">
            <span class="bre-b-card__footer-powered">Powered By</span>
            <img src="./assets/svg/bre-b/mobile-logo.svg" alt="CL!NNG" class="bre-b-card__footer-clinng-logo">
          </div>
        </div>
      </div>
    }

    @if (!isInitialLoading && estado === estadoModel.PENDING) {
      <div class="bre-b-card__pending">
        <img src="./assets/img/bre-b.png" alt="Bre-B" class="bre-b-card__logo">

        <h3 class="bre-b-card__instruction">Realiza el pago desde tu app de banco con los siguientes datos</h3>
        <p class="bre-b-card__subinstruction">Una vez recibamos el pago, esta pantalla se actualizará.</p>

        <div class="bre-b-card__fields">
          <div class="bre-b-field">
            <label class="bre-b-field__label">Llave</label>
            <div class="bre-b-field__input-container">
              <input type="text" class="bre-b-field__input" [value]="key" readonly>
              <button class="bre-b-field__copy-btn" (click)="copyToClipboard(key)">
                <span class="bre-b-field__copy-text">Copiar</span>
              </button>
            </div>
          </div>

          <div class="bre-b-field">
            <label class="bre-b-field__label">Valor</label>
            <div class="bre-b-field__input-container">
              <input type="text" class="bre-b-field__input" [value]="value" readonly>
              <button class="bre-b-field__copy-btn" (click)="copyToClipboard(value)">
                <span class="bre-b-field__copy-text">Copiar</span>
              </button>
            </div>
          </div>
        </div>

        <div class="bre-b-card__timer">
          <mat-icon class="bre-b-card__timer-icon">schedule</mat-icon>
          <span class="bre-b-card__timer-text">Vence en {{ timer }}</span>
        </div>

        <div class="bre-b-card__footer-logo" [class.show-on-mobile-pending]="estado === estadoModel.PENDING">
          <span class="bre-b-card__footer-powered">Powered By</span>
          <img src="./assets/svg/bre-b/mobile-logo.svg" alt="CL!NNG" class="bre-b-card__footer-clinng-logo">
        </div>
      </div>
    }

    @if (!isInitialLoading && estado === estadoModel.QR) {
      <div class="bre-b-card__qr-content">
        <div class="bre-b-card__qr-main">
          <h2 class="bre-b-card__qr-lead">
            Escanea el código QR desde la app de tu banco para continuar
          </h2>
          <div class="bre-b-card__qr-card">
            <div class="bre-b-card__qr-image">
              <img [src]="qrImageSrc" alt="QR de pago" />
            </div>
            <div class="bre-b-card__qr-info">
              <p class="bre-b-card__qr-info-title">
                A través de la sección Bre-b en tu app de banco
              </p>
              <p class="bre-b-card__qr-info-amount">
                Pagar {{ value }}
              </p>
            </div>
          </div>
        </div>
        <div class="bre-b-card__footer-logo bre-b-card__footer-logo--qr-mobile">
          <span class="bre-b-card__footer-powered">Powered By</span>
          <img src="./assets/svg/bre-b/mobile-logo.svg" alt="CL!NNG" class="bre-b-card__footer-clinng-logo">
        </div>
      </div>
    }

    @if (!isInitialLoading && showStandardProcessingView) {
      <div class="bre-b-card__loading-content" role="status" aria-live="polite" [attr.aria-busy]="isGeneratingMethod || estado === estadoModel.LOADING">
        <h2 class="bre-b-card__loading-title">PROCESANDO</h2>
        
        <div class="bre-b-card__loading-spinner">
          <img src="./assets/svg/bre-b/loading-spinner.svg" alt="Loading" class="bre-b-card__loading-spinner-img">
        </div>
        
        <p class="bre-b-card__loading-message">Por favor no cierres ni actualices esta ventana. Estamos procesando tu pago.</p>

        <div class="bre-b-card__footer-logo" [class.show-on-mobile-loading]="showStandardProcessingView">
          <span class="bre-b-card__footer-powered">Powered By</span>
          <img src="./assets/svg/bre-b/mobile-logo.svg" alt="CL!NNG" class="bre-b-card__footer-clinng-logo">
        </div>
      </div>
    }

    @if (estado === estadoModel.APPROVED) {
      <div class="bre-b-card__success-content">
        <div class="bre-b-card__success-body">
          <div class="bre-b-card__success-icon">
            <img src="./assets/svg/bre-b/success.svg" alt="Success" class="bre-b-card__success-icon-img">
          </div>

          <h2 class="bre-b-card__success-title">¡Pago exitoso!</h2>

          <div class="bre-b-card__success-message">
            <p class="bre-b-card__success-message-line">Disfruta de tu compra.</p>
            <p class="bre-b-card__success-message-line">Esperemos verte de regreso.</p>
          </div>
        </div>

        <div class="bre-b-card__footer-container" [class.show-on-mobile-success]="estado === estadoModel.APPROVED">
          <div class="bre-b-card__footer-logo">
            <span class="bre-b-card__footer-powered">Powered By</span>
            <img src="./assets/svg/bre-b/mobile-logo.svg" alt="CL!NNG" class="bre-b-card__footer-clinng-logo">
          </div>
          
          <button class="bre-b-card__success-button" (click)="goBack()">
            Retornar al comercio
          </button>
        </div>
      </div>
    }

    @if (!isInitialLoading && estado === estadoModel.REFUSED) {
      <div class="bre-b-card__error-content">
        <div class="bre-b-card__error-body">
          <div class="bre-b-card__error-icon">
            <img src="./assets/svg/bre-b/error.svg" alt="Error" class="bre-b-card__error-icon-img">
          </div>

          <h2 class="bre-b-card__error-title">Pago rechazado</h2>

          <div class="bre-b-card__error-message">
            <p class="bre-b-card__error-message-line">No pudimos completar el pago.</p>
            <p class="bre-b-card__error-message-line">Intenta nuevamente.</p>
          </div>
        </div>

        <div class="bre-b-card__footer-container" [class.show-on-mobile-error]="estado === estadoModel.REFUSED">
          <div class="bre-b-card__footer-logo">
            <span class="bre-b-card__footer-powered">Powered By</span>
            <img src="./assets/svg/bre-b/mobile-logo.svg" alt="CL!NNG" class="bre-b-card__footer-clinng-logo">
          </div>

          <button class="bre-b-card__error-button" (click)="goBack()">
            Retornar al comercio
          </button>
        </div>
      </div>
    }

    @if (!isInitialLoading && estado === estadoModel.EXPIRED) {
      <div class="bre-b-card__error-content">
        <div class="bre-b-card__error-body">
          <div class="bre-b-card__error-icon">
            <img src="./assets/svg/bre-b/error.svg" alt="Error" class="bre-b-card__error-icon-img">
          </div>

          <h2 class="bre-b-card__error-title">Tiempo expirado</h2>

          <div class="bre-b-card__error-message">
            @if (expirationFormattedColombia) {
              <p class="bre-b-card__error-message-line">El plazo venció el {{ expirationFormattedColombia }}</p>
            }
            <div class="bre-b-card__error-message-compact">
              <p class="bre-b-card__error-message-line">Dirígete al comercio para realizar una</p>
              <p class="bre-b-card__error-message-line">nueva solicitud.</p>
            </div>
          </div>
        </div>

        <div class="bre-b-card__footer-container" [class.show-on-mobile-expired]="estado === estadoModel.EXPIRED">
          <div class="bre-b-card__footer-logo">
            <span class="bre-b-card__footer-powered">Powered By</span>
            <img src="./assets/svg/bre-b/mobile-logo.svg" alt="CL!NNG" class="bre-b-card__footer-clinng-logo">
          </div>

          <button class="bre-b-card__error-button" (click)="goBack()">
            Retornar al comercio
          </button>
        </div>
      </div>
    }
  </div>
  </div>
</article>

